export const EMPLOYEE_INSURANCE_WIDGET_NAME = 'WidgetEmployeeInsurance'
